import React, { useEffect, useRef } from "react"; 
import { createPortal } from "react-dom";
import { isKey } from "./UI/KeyPressHelper";
import "../styles/modal.css";

const Modal = ({ isOpen, onClose, children }) => {
  const modalRef = useRef(null); 

  useEffect(() => {
    if (isOpen && modalRef.current) {
      modalRef.current.focus();
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const _handleKeyDownCloseExit = (e) => {
    e.stopPropagation();
    if (isKey(e, "Escape")) {
      onClose();
    }
  };

  return createPortal(
    <div
      ref={modalRef} 
      className="modal-overlay"
      onClick={onClose}
      onKeyDown={_handleKeyDownCloseExit} 
      tabIndex={-1} 
    >
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    document.getElementById("modal-root")
  );
};

export default Modal;
